<template>
  <v-card style="flex: 1; margin-top: 10px; margin-left: 10px; margin-right: 5px;">
    <div style="display: flex; margin-top: 10px;">
      <div style="flex: 1;">
        <span class="titledashboard">{{$t("nombre_de_site")}}</span>
        <div style="margin-left: 10px; justify-content: center; display: flex; align-items: center; margin-top: 10px;">
          <span style="font-size: 30px; font-weight: bold; margin-top: 5px; margin-bottom: 5px;">{{ liste_dashboard.nb_de_site }}</span>
        </div>
      </div>

      <div class="containerdashboard">
        <span class="titledashboard">{{$t("pr_parc")}}</span>
        <div style="margin-left: 10px; display: flex; margin-top: 10px;">
          <div>
            <div ref="myChartContainer1" style="width:100%; margin: auto; max-width: 125px;"></div>
          </div>
          <div style="flex: 1;">
            <div  style="margin-top: 8px; margin-bottom: -10px;">
              <span style="font-size: 18px;">{{ liste_dashboard.pr_clean_parc_evo.toFixed(1) }}%</span>
              <v-icon v-if="liste_dashboard.pr_clean_parc_evo >= 0" color="#12D600" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-top-right</v-icon>
              <v-icon v-if="liste_dashboard.pr_clean_parc_evo < 0 && liste_dashboard.pr_clean_parc_evo >= -2" color="orange" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-bottom-right</v-icon>
              <v-icon v-if="liste_dashboard.pr_clean_parc_evo < -2" color="#FA4C4C" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-bottom-right</v-icon>
            </div>
            <div>
              <span style="font-size: 12px;">{{$t("_evolutions_")}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="containerdashboardtwo" @click="toggleMenu" style="cursor: pointer;">
        <span class="titledashboard">{{$t("pertes_vs_modele_energie")}}</span>
        <div style="margin-left: 10px; justify-content: center; display: flex; align-items: center; margin-top: 10px; gap: 20px;">
          <span style="font-size: 27px; font-weight: bold; margin-top: 5px; margin-bottom: 5px;">{{ liste_dashboard.pertes_vs_modele_energie }} %</span>
          <div style="display: flex; align-items: center;">
            <div>
              <div ref="myChartContainer3" class="graph"></div>                  
            </div>
            <div style="flex: 1; margin-left: -10px;">
              <div style="margin-top: 8px; margin-bottom: -10px;">
                <span style="font-size: 18px;">{{ liste_dashboard.pertes_vs_modele_energie_evo }} %</span>
                <v-icon v-if="liste_dashboard.pertes_vs_modele_energie_evo >= 0" color="#12D600" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-top-right</v-icon>
                <v-icon v-if="liste_dashboard.pertes_vs_modele_energie_evo < 0 && liste_dashboard.pertes_vs_modele_energie_evo >= -2" color="orange" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-bottom-right</v-icon>
                <v-icon v-if="liste_dashboard.pertes_vs_modele_energie_evo < -2" color="#FA4C4C" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-bottom-right</v-icon>
              </div>
              <div>
                <span style="font-size: 12px;">{{$t("_evolutions_")}}</span>
              </div>
            </div>
          </div>

        </div>
        <v-menu
          v-model="menuVisible"
          offset-y
          class="custom-nudge"
          transition="scale-transition"
          attach
        >
          <v-card>
            <v-treeview
              :items="staticTree"
              :transition="true"
              open-on-click
              dense
              style="width: 350px;"
            >
              <template v-slot:label="{ item }" style="margin: 30px;">
                <span
                  v-if="item.level === 0"
                  v-bind:style="'color: #000000;'"
                  @click.stop
                >
                  {{ item.name }}
                </span>

                <span
                  v-else-if="item.level === 1"
                  v-bind:style="'color: rgba(0,0,0,.6); display: block; font-size: 14px;'"
                  @click.stop
                >
                  {{ item.name }}
                </span>
              </template>

              <template v-slot:append="{ item }">
                <span
                  v-if="item.level === 0"
                  v-bind:style="'color: #000000;'"
                  @click.stop
                >
                  <b>{{ item.pourcent }}%</b>
                </span>

                <span
                  v-else-if="item.level === 1"
                  v-bind:style="'color: rgba(0,0,0,.6); font-size: 14px; margin-right: 30px;'"
                  @click.stop
                >
                  <b>{{ item.pourcent }} %</b>
                </span>
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <div class="containerdashboardtwo">
        <span class="titledashboard" style="font-size: 15px;">{{$t("info_alarmes")}}</span>
        <div class="dashboard-content">
          <div class="icon-container">
            <div class="icon-item">
              <v-icon color="#44FF79" small>mdi-circle</v-icon>
              <span class="icon-label">Sites sans alarmes:  {{ liste_dashboard.without_alarms }}</span>
            </div>
            <div class="icon-item">
              <v-icon color="#FA4C4C" small>mdi-circle</v-icon>
              <span class="icon-label">Alarmes majeur:  {{ liste_dashboard.minor_alarms }}</span>
            </div>
            <div class="icon-item">
              <v-icon color="#FFA500" small>mdi-circle</v-icon>
              <span class="icon-label">Alarmes mineur:  {{ liste_dashboard.major_alarms }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; margin-top: 20px; margin-bottom: 10px;">
      <div style="flex: 1;">
        <span class="titledashboard">{{$t("pc_totale")}}</span>
        <div style="margin-left: 10px; justify-content: center; display: flex; align-items: center; margin-top: 10px; margin-bottom: 15px;">
          <span style="font-size: 30px; font-weight: bold; margin-top: 5px; margin-bottom: 5px;">
            {{ liste_dashboard.pc_totale.toFixed(1) }} MW<span style="font-weight: normal;">p</span>
          </span>
        </div>
      </div>

      <div class="containerdashboard">
        <span class="titledashboard">{{$t("disponibilite_parc")}}</span>
        <div style="display: flex; align-items: center;">
          <div>
            <div ref="myChartContainer3" class="graph"></div>                  
          </div>
          <div style="flex: 1;">
            <div style="margin-top: 8px; margin-bottom: -10px;">
              <span style="font-size: 18px;">{{liste_dashboard.disponibilite_parc_evo}} %</span>
              <v-icon v-if="liste_dashboard.disponibilite_parc_evo >= 0" color="#12D600" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-top-right</v-icon>
              <v-icon v-if="liste_dashboard.disponibilite_parc_evo < 0 && liste_dashboard.disponibilite_parc_evo >= -2" color="orange" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-bottom-right</v-icon>
              <v-icon v-if="liste_dashboard.disponibilite_parc_evo < -2" color="#FA4C4C" style="margin-left: 5px; margin-bottom: 3px;">mdi-arrow-bottom-right</v-icon>
            </div>
            <div>
              <span style="font-size: 12px;">{{$t("_evolutions_")}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="containerdashboardtwo"  @click="toggleMenu" style="cursor: pointer;">
        <span class="titledashboard">{{$t("pertes_recouvrables")}}</span>
        <div>
          <div style="margin-left: 10px; justify-content: center; display: flex; align-items: center; margin-top: 10px; gap: 20px">
            <span style="font-size: 22px; font-weight: bold; margin-top: 10px; margin-bottom: 5px;">{{ liste_dashboard.pertes_recouvrables }}%</span>
          </div>
        </div>
      </div>

      <div class="containerdashboardtwo">
        <div ref="myChartContainer6" style="width:100%; max-width:150px;margin-bottom: 5px; margin-left: 20%; margin-top: 5%;"></div>
      </div>
    </div>
  </v-card>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    liste_dashboard: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartpr: null,
      menuVisible: false,
      menuStyle: {},
      staticTree: [
        {
          id: 1,
          name: "Pertes hors plages onduleurs",
          level: 0,
          pourcent: 60,
          children: [
            {
              id: 2,
              name: "clipping (Plage MPPT) Vmax",
              level: 1,
              pourcent: 80,
            },
            {
              id: 3,
              name: "clipping (Plage MPPT) Vmin",
              level: 1,
              pourcent: 35,
            },
            {
              id: 4,
              name: "Encrêtage en Intensité",
              level: 1,
              pourcent: 73,
            },
            {
              id: 5,
              name: "Encrêtage en Puissance",
              level: 1,
              pourcent: 87,
            },
          ],
        },
        {
          id: 2,
          name: "Pertes persistantes",
          level: 0,
          pourcent: 35,
          children: [
            {
              id: 2,
              name: "Autres pertes persistantes",
              level: 1,
              pourcent: 80,
            },
            {
              id: 3,
              name: "Chaines déconnectées",
              level: 1,
              pourcent: 13,
            },
            {
              id: 4,
              name: "Référence photocourant",
              level: 1,
              pourcent: 45,
            },
            {
              id: 5,
              name: "Référence Tension",
              level: 1,
              pourcent: 32,
            },
          ],
        },
        {
          id: 3,
          name: "Pertes ponctuelles",
          level: 0,
          pourcent: 80,
          children: [
            {
              id: 2,
              name: "Autres pertes ponctuelles",
              level: 1,
              pourcent: 24,
            },
            {
              id: 3,
              name: "Pertes diodes intermittentes",
              level: 1,
              pourcent: 27,
            },
          ],
        },
        {
          id: 4,
          name: "Sur-pertes conversion AC-DC",
          pourcent: 78,
          level: 0,
          children: [
            {
              id: 2,
              name: "Pertes conversion AC-DC",
              level: 1,
              pourcent: 80,
            },
          ],
        }
      ]
    };
  },

  computed: {
    calculatedNudge() {
      return window.innerWidth * 0.5;
    },
  },

  mounted() {
    this.createChart();
    this.createbluechart();
  },

  watch: {
    liste_dashboard: {
      handler() {
        this.updateChart();
      },
      immediate: true,
    },
  },

  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },

    createChart() {
      const ctx1 = document.createElement("canvas");
      this.$refs.myChartContainer1.appendChild(ctx1);

      const ctx6 = document.createElement("canvas");
      this.$refs.myChartContainer6.appendChild(ctx6);

      const yValues = [80, 15, 5];
      const yValues1 = [40, 60];
      const barColors = ["#44FF79", "#FFA500", "#FA4C4C"];
      const barColors1 = ["#12D600", "#ffffff"];

      this.chartpr = new Chart(ctx1, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors1,
              borderWidth: 0,
              data: yValues1,
            },
          ],
        },
        options: {
          cutoutPercentage: 75,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });

      this.chartalarmes = new Chart(ctx6, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors,
              borderWidth: 0,
              data: yValues,
            },
          ],
        },
        options: {
          cutoutPercentage: 75,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });

      this.addCenterCircleAndTextgreen(this.$refs.myChartContainer1, this.liste_dashboard.pr_clean_parc);
    },

    createbluechart() {
      const ctx3 = document.createElement("canvas");
      this.$refs.myChartContainer3.appendChild(ctx3);

      const yValues = [90, 10];
      const barColors = ["#344BFD", "#ffffff"];

      this.chartdisponibilite = new Chart(ctx3, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors,
              borderWidth: 0,
              data: yValues,
            },
          ],
        },
        options: {
          cutoutPercentage: 90,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });
      this.addCenterCircleAndText(this.$refs.myChartContainer3, "NA%");
    },

    addCenterCircleAndText(container, percentage) {
      const blueCircle = document.createElement("div");
      blueCircle.style.position = "absolute";
      blueCircle.style.top = "51%";
      blueCircle.style.left = "50%";
      blueCircle.style.transform = "translate(-50%, -50%)";
      blueCircle.style.width = "50px";
      blueCircle.style.height = "50px";
      blueCircle.style.backgroundColor = "#BDEAFF";
      blueCircle.style.borderRadius = "50%";
      blueCircle.style.pointerEvents = "none";

      const centerText = document.createElement("div");
      centerText.innerText = `${percentage.toFixed(0)}%`;
      centerText.style.position = "absolute";
      centerText.style.top = "53%";
      centerText.style.left = "52%";
      centerText.style.transform = "translate(-50%, -50%)";
      centerText.style.fontSize = "14px";
      centerText.style.fontWeight = "bold";
      centerText.style.color = "black";
      centerText.style.pointerEvents = "none";
      container.style.position = "relative";

      container.appendChild(blueCircle);
      container.appendChild(centerText);
    },

    addCenterCircleAndTextgreen(container, percentage) {
      const blueCircle = document.createElement("div");
      blueCircle.style.position = "absolute";
      blueCircle.style.top = "50%";
      blueCircle.style.left = "50%";
      blueCircle.style.transform = "translate(-50%, -50%)";
      blueCircle.style.width = "51px";
      blueCircle.style.height = "51px";
      blueCircle.style.backgroundColor = "#C2FFBC";
      blueCircle.style.borderRadius = "50%";
      blueCircle.style.pointerEvents = "none";

      const centerText = document.createElement("div");
      centerText.innerText = `${percentage.toFixed(0)}%`;
      centerText.style.position = "absolute";
      centerText.style.top = "53%";
      centerText.style.left = "52%";
      centerText.style.transform = "translate(-50%, -50%)";
      centerText.style.fontSize = "14px";
      centerText.style.fontWeight = "bold";
      centerText.style.color = "black";
      centerText.style.pointerEvents = "none";
      container.style.position = "relative";

      container.appendChild(blueCircle);
      container.appendChild(centerText);
    },

    updateChart() {
      if (this.chartdisponibilite) {
        this.chartdisponibilite.data.datasets[0].data[0] = this.liste_dashboard.disponibilite_parc;
        this.chartdisponibilite.data.datasets[0].data[1] = 100 - this.liste_dashboard.disponibilite_parc;
        this.chartdisponibilite.update();
        this.addCenterCircleAndText(this.$refs.myChartContainer3, this.liste_dashboard.disponibilite_parc);
      }

      if (this.chartalarmes) {
        let nbr = 100 / (this.liste_dashboard.without_alarms + this.liste_dashboard.minor_alarms + this.liste_dashboard.major_alarms);
        this.chartalarmes.data.datasets[0].data[0] = this.liste_dashboard.without_alarms * nbr;
        this.chartalarmes.data.datasets[0].data[1] = this.liste_dashboard.minor_alarms * nbr;
        this.chartalarmes.data.datasets[0].data[2] = this.liste_dashboard.major_alarms * nbr;
        this.chartalarmes.update();      
      }

      if (this.chartpr) {
        this.chartpr.data.datasets[0].data[0] = this.liste_dashboard.pr_clean_parc;
        this.chartpr.data.datasets[0].data[1] = 100 - this.liste_dashboard.pr_clean_parc;
        this.chartpr.update();
        this.addCenterCircleAndTextgreen(this.$refs.myChartContainer1, this.liste_dashboard.pr_clean_parc);        
      }
    },
  }
};
</script>

<style>
  .titledashboard {
    margin-left: 10px;
    font-size: 13px;
    font-weight: bold;
  }
  .containerdashboard {
    flex: 1;
    border-left: 1px solid black;
  }

  .containerdashboardtwo {
    flex: 1;
    border-left: 3px solid black;
  }

  .dashboard-content {
    display: flex;
    align-items: flex-start;
    margin-top: 5px;
    margin-left: 10px;
  }

.icon-container {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}

.treeview-container {
  max-height: 300px;
  overflow-y: auto;
}

.icon-item {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.icon-label {
  margin-left: 5px;
  font-size: 13px;
  font-weight: bold;
  color: rgba(0,0,0,.6);
}

  .graph {
    width:100%;
    max-width:125px;
    margin-top: 15px;
    margin-bottom: 5px;
    margin-left: 15px;
  }

  .custom-nudge {
    position: relative;
    left: 101%;
    top: -78px;
  }
</style>